'use client'

import { toast } from '@/core/lib/toast'

import { api, ApiError } from '@/features/veluvit/services/api'

/**
 * 작가 초대 링크(`/?creatorInvite=코드`) — 초대받은 사람이 회원이 되면 첫 작품을 만들기 전에 서버에 등록한다
 * (POST /creator/invite/accept/). 게스트로 들어왔으면 코드를 이 브라우저에 맡겨 두고, 회원 로그인·가입 뒤 등록한다.
 */
const KEY = 'veluvit:creator-invite'

/** 주소창의 초대 코드를 맡아 두고 주소에서 지운다 */
export function holdInvite() {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  const code = url.searchParams.get('creatorInvite')
  if (!code) return
  url.searchParams.delete('creatorInvite')
  window.history.replaceState(
    window.history.state,
    '',
    url.pathname + url.search + url.hash
  )
  try {
    localStorage.setItem(KEY, code)
  } catch {
    // 저장이 막힌 브라우저 — 이번 방문 동안만 등록을 시도한다
  }
  toast.show('작가 초대를 받았어요 · 회원으로 로그인하면 등록돼요', {
    duration: 3200,
  })
}

let accepting = false

/** 회원이면 맡아 둔 초대를 등록한다. 서버가 거절한 초대(본인 초대·이미 작품이 있음·다른 초대 등록됨·기간 종료)는 버린다 */
export async function acceptInvite() {
  let code: string | null = null
  try {
    code = localStorage.getItem(KEY)
  } catch {
    return
  }
  if (!code || accepting) return
  accepting = true
  try {
    await api('/creator/invite/accept/', { code })
    localStorage.removeItem(KEY)
    toast.show('작가 초대를 등록했어요')
  } catch (error) {
    // 연결 문제는 다음 방문에 다시 시도하고, 서버가 판단한 거절만 알리고 버린다
    if (
      error instanceof ApiError &&
      error.status >= 400 &&
      error.status < 500
    ) {
      localStorage.removeItem(KEY)
      toast.show(error.message, { duration: 3200 })
    }
  } finally {
    accepting = false
  }
}
